import { atom } from 'jotai'
import { ChallengeService } from '@duck/api-definitions'

// Atom to track if we're currently saving
export const isSavingWorkAtom = atom<boolean>(false)

// Atom to track the last save date
export const lastSaveWorkDateAtom = atom<Date>(new Date())

export const workTimeAtom = atom<number>(0)

// Atom to track the current solution
export const currentSolutionAtom = atom<string>('')

// Atom to track the current query
export const currentQueryAtom = atom<string>('')

// Atom for the current challenge ID (used by components rendered without props, e.g. workspace tabs)
export const challengeIdAtom = atom<string | null>(null)

// Atom for the current task (used by PythonNotebook to access dataBank for table names)
export const taskAtom = atom<ChallengeService.ChallengeInfo['task'] | null>(null)

// Atom for the current challenge (used by PythonNotebook to access workState.jNotebook)
export const challengeAtom = atom<ChallengeService.ChallengeInfo['challenge'] | null>(null)

// Atom to track the current notes (workspace notes tab)
export const currentNotesAtom = atom<string>('')

